import type { ReactNode } from "react";
import TaskOptionSheetHeader from "../TaskOptionSheetHeader/TaskOptionSheetHeader";

type Props = {
  children: ReactNode;
  onBack: () => void;
  title?: string;
  accentColor?: string;
};

export default function OptionsWrapper({
  children,
  onBack,
  title = "Options",
  accentColor,
}: Props) {
  return (
    <div className="ui-options-wrapper mx-auto w-full max-w-2xl pb-6">
      <TaskOptionSheetHeader
        onBack={onBack}
        title={title}
        accentColor={accentColor}
      />
      <div className="ui-options-wrapper__content space-y-5 px-1">
        {children}
      </div>
    </div>
  );
}
